import styled from 'styled-components6';

const TruncatedMessage = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'hasContent', //remove console warning of invalid prop passed to HTML element
})<{ hasContent: boolean }>`
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 4;
    overflow: hidden;
    max-height: 4.8em;
    -webkit-box-orient: vertical;
    color: ${(props) =>
        props.hasContent
            ? 'var(--rwl-palette-gray-600)'
            : 'var(--rwl-palette-gray-500)'};
    line-height: 1.2em;
    font-style: ${(props) => (props.hasContent ? 'normal' : 'italic')};
`;

interface ReviewMessageContent {
    message: string;
}

interface ReviewMessageProps {
    content: ReviewMessageContent;
}

export const ReviewMessage = ({ content }: ReviewMessageProps): JSX.Element => {
    const displayMessage =
        content.message?.length > 0
            ? content.message
            : 'Additional comments were not provided';
    return (
        <TruncatedMessage hasContent={content.message?.length > 0}>
            {displayMessage}
        </TruncatedMessage>
    );
};
